/**
 * Imgix URL formatting Service
 */
export class ImgixService {
    /**
     * Returns imgix formatted URL with included breakpoint splits, based on settings provided.
     * @param url
     * @param useSrcset
     * @param imageQualityPercentage
     */
    private static processedUrl: string;

    public static getImgixUrl(url: string, useSrcset?: boolean, imageQualityPercentage: number = 75, maxHeight: number = null): string {
        if (!url) {
            return '';
        } else if (url.indexOf('imgix') === -1 || url.indexOf('.svg') > 0) {
            return url;
        }

        const breakpoints = [
            '140', // Desktop LLDP thumbnails
            //      '235', // Desktop Saved Listings 1200px width window
            //      '270', // Desktop gallery carousel, Desktop Saved Listings 1366px width window
            //      '285', // Desktop Saved Listings 1440px and 1920px width window
            //      '300', // Mobile carousel
            //      '315', // Desktop Saved Listings 1600px width window
            '320', // Desktop LDP Suggested Listings carousel
            //      '385', // Desktop Saved Listings 2560px width window
            //      '525', // Desktop LDP 1200px width window
            //      '600', // Desktop LDP 1366px width window
            //      '630', // Desktop LDP 1440px and LLDP 1200px width window
            '640', // Desktop LDP 1920px width window
            //      '700', // Desktop LDP 1600px width window
            //      '715', // Desktop LLDP 1366px width window
            //      '755', // Desktop LLDP 1440px width window
            //      '760', // Desktop LLDP 1920px width window
            //      '830', // Desktop LDP Gallery 1200px width window
            //      '840', // Desktop LLDP 1600px width window
            '850', // Desktop LDP 2560px width window
            //      '945', // Desktop LDP Gallery 1366px and 1920px width window
            //      '995', // Desktop LDP Gallery 1440px width window
            //      '1020', // Desktop LLDP 2560px width window
            //      '1105', // Desktop LDP Gallery 1600px width window
            '1255', // Desktop LDP Gallery and LLDP Gallery 2560px width window
            '1440',
            '1920',
            '2160',
        ];

        let queryParams = '';

        // Set different parameters depending on image type
        if (url.indexOf('.gif') > 0) {
            queryParams =
                '';
        } else {
            queryParams =
                '?fit=max' +
                '&auto=format,compress' +
                '&fm=pjpg' +
                '&cs=srgb' +
                '&q=' + imageQualityPercentage;
        }

        // maxHeight provided - don't use srcSet but define image height directly
        if (maxHeight) {
            this.processedUrl = url + queryParams +
                (queryParams === '' ? '' : '&') + 'h=' + maxHeight;
        }
        // srcSet formatting
        else if (useSrcset) {
            this.processedUrl = breakpoints.map((value) => url + queryParams +
                (queryParams === '' ? '' : '&') + 'w=' + value + ' ' + value + 'w').join(', ');
        } else {
            this.processedUrl = url + queryParams;
        }
        return this.processedUrl;
    }
}

